
import GenreMaker from '../anychart/genreMaker'; 

var ScatterChart = class ScatterChart extends GenreMaker {

    setData(state){
        console.log("entry scatter");
        super.setData(state);
        
        this.chart.xAxis();
        this.chart.yAxis();
        if(this.ifIncluded("line")){
            this.chart.line(this.data[0]);
        }else if(this.ifIncluded("bubble")){
            this.chart.bubble(this.data[0])
        }else{
            this.chart.marker(this.data[0])
        }
    }

    createChart(){
        var chart = anychart.scatter();
        return chart;
    }; 
};
    
GenreMaker.scatter = ScatterChart;

export var ScatterChart;



// WEBPACK FOOTER //
// ./src/anychart/scatterChart.js